import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import LineSeparator from '../../../elements/LineSeparator'
import Card from '../components/Card'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { withModifiers } from '../../../helpers/withModifiers'
import { useRouter } from 'next/router'
import LazyImage from '../../../elements/LazyImage'

const Welcome = ({
  property,
  video,
  background,
  title,
  description,
  configuration,
  translations,
  cardTranslations,
  cloudflare,
  sold = false,
  ...props
}) => {
  const { isDesktop, isTablet, isMobile } = useResponsive()
  const router = useRouter()

  // Check if the URL can be modified for different sizes (Cloudflare)
  const isCloudflare =
    typeof background === 'string' && background.includes('imagedelivery.net')

  // Create URLs for different sizes if possible, otherwise use the original
  const getImageUrl = (size) => {
    if (!background || typeof background !== 'string') return null
    if (!isCloudflare) return background
    return background.replace(/\/([^/]+)$/, `/${size}`)
  }

  // Create image URLs for different sizes
  const imageUrls = {
    small: getImageUrl('360'),
    medium: getImageUrl('640'),
    large: getImageUrl('960'),
    xlarge: getImageUrl('1980')
  }

  const imageProps = {
    src: imageUrls.xlarge,
    alt: translations.welcome.content.imageAlt[router.locale],
    sizes:
      '(max-width: 360px) 360px, (max-width: 640px) 640px, (max-width: 960px) 960px, 1980px',
    srcSet: imageUrls.xlarge
      ? `${imageUrls.medium} 360w,
             ${imageUrls.medium} 640w,
             ${imageUrls.large} 960w,
             ${imageUrls.xlarge} 1980w`
      : null
  }

  return (
    <>
      <Section
        video={video}
        grayscale={sold}
        // bg={imageUrls.xlarge}
        cloudflare={cloudflare}
        variant={['p0', 'image-full']}
        className={styles.welcome}
      >
        <div
          className={withModifiers(
            'welcome__image',
            [sold && 'grayscale'],
            styles
          )}
        >
          <LazyImage
            priority
            fetchpriority="high"
            width={1980}
            layout="fill"
            objectPosition="center"
            objectFit="cover"
            height={1080}
            srcSet={imageProps.srcSet}
            sizes={imageProps.sizes}
            src={imageUrls.xlarge}
            alt={imageProps.alt}
          />
        </div>

        <div className={styles.welcome__content}>
          <Container>
            <Columns variant={['-align-bottom', '-distribute-between']}>
              <Column
                className={styles.welcome__left}
                spans={isTablet ? 12 : isDesktop ? 7 : 6}
              >
                <span className={styles.welcome__tag}>
                  {property?.city}{' '}
                  {(property?.address?.country && property?.region_side) ||
                    property?.locations?.title}
                </span>

                <h1 className={styles.welcome__title}>{title}</h1>

                {property.promo_code_description && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: property.promo_code_description
                    }}
                    className={styles.welcome__promo}
                  ></div>
                )}

                <Columns>
                  <div className={styles.welcome__details}>
                    <LineSeparator width={isMobile && 31} />

                    {(description || configuration) && (
                      <div className={styles.welcome__description}>
                        {description && (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: description
                            }}
                            className={styles.welcome__paragraph}
                          ></p>
                        )}

                        {configuration && <span>{configuration}</span>}
                      </div>
                    )}
                  </div>
                </Columns>
              </Column>
              <Column spans={isTablet ? 12 : 5}>
                <Card
                  cardTranslations={cardTranslations}
                  property={property}
                  expandable
                  translations={translations.welcome.card}
                  {...props}
                />
              </Column>
            </Columns>
          </Container>
        </div>
      </Section>
    </>
  )
}

export default Welcome
